import React from "react";
import { motion } from "framer-motion";
import { ArrowRight, ShieldCheck, Ban, BadgeCheck } from "lucide-react";
import { fadeUp, stagger, viewport } from "@/lib/motion";

const NOTES = [
  { icon: ShieldCheck, label: "Factory Direct Purchasing" },
  { icon: Ban, label: "No Product Markups" },
  { icon: BadgeCheck, label: "Verified Turkish Manufacturers" },
];

export default function FinalCta() {
  return (
    <section className="py-24 sm:py-32" data-testid="final-cta-section">
      <div className="dm-container">
        <motion.div variants={stagger} initial="hidden" whileInView="visible" viewport={viewport}
          className="relative overflow-hidden dm-card px-6 sm:px-14 py-16 sm:py-20 text-center">
          <div className="absolute inset-0 dm-grid-bg [mask-image:radial-gradient(ellipse_55%_60%_at_50%_40%,black,transparent)]" />
          <div className="relative">
            <motion.h2 variants={fadeUp}
              className="text-3xl sm:text-4xl lg:text-5xl font-extrabold text-slate-900 leading-[1.1] max-w-2xl mx-auto">
              Build one container.<br className="hidden sm:block" /> Manage one procurement operation.
            </motion.h2>
            <motion.p variants={fadeUp} className="mt-5 text-base sm:text-lg text-slate-500 leading-relaxed max-w-2xl mx-auto">
              Purchase directly from verified Turkish manufacturers while DeMaxtore coordinates every stage of your multi-manufacturer procurement operation through one connected Workspace.
            </motion.p>
            <motion.div variants={fadeUp} className="mt-9 flex flex-wrap justify-center gap-3">
              <button className="dm-btn-primary" data-testid="final-primary-cta">Build Your SmartContainer™<ArrowRight className="h-4 w-4" strokeWidth={2} /></button>
              <button className="dm-btn-secondary" data-testid="final-secondary-cta">Create Your Free Workspace</button>
            </motion.div>
            <motion.div variants={fadeUp} className="mt-9 flex flex-wrap items-center justify-center gap-x-7 gap-y-3">
              {NOTES.map((n) => (
                <span key={n.label} className="inline-flex items-center gap-2 text-sm font-medium text-slate-500">
                  <n.icon className="h-4 w-4 text-blue-600" strokeWidth={1.75} />{n.label}
                </span>
              ))}
            </motion.div>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
